export default __webpack_public_path__ + "static/media/C_wdt_c_cap_1.8253c1c5.mp3";